<app-data-state [loading]="loading$ | async" [error]="error$ | async">
  <div class="mb-3">
    <div
      class="bg-white border border-red-200 rounded-md p-5 flex items-start gap-3"
    >
      <lucide-icon class="text-red-600" name="circle-alert"></lucide-icon>

      <div>
        <div class="text-red-600 font-semibold text-lg mb-1.5">
          Dernier message d'erreur
        </div>
        <p class="text-base m-0">
          {{translatedErrorMessage}}
        </p>
      </div>
    </div>
  </div>
</app-data-state>
